import React from 'react'
import { COLUMN_TYPES, Icon, reducers } from '@adc/ui-morpheus'
import { ENDPOINTS } from '../../constants/tableTypes'

const getDefaultProps = width => ({
  width,
  isResizable: false,
  isReorderable: false,
  isVisible: true,
})

export const tableConfig = {
  config: {
    entityKey: ENDPOINTS,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Selected',
      apiRef: 'selected', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.CHECKBOX,
        colProps: { width: 40, fixed: true },
      },
    },
    {
      name: 'Service Name',
      apiRef: 'service_name',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          searchable: true,
        },
      },
    },
    {
      name: 'Endpoint',
      apiRef: 'path',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(500),
          searchable: true,
        },
      },
    },
    {
      name: 'Method',
      apiRef: 'http_method',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: { ...getDefaultProps(100), searchable: true },
      },
    },
    {
      name: 'Is Authorization Required',
      apiRef: 'is_authorization_required',
      columnDefinition: {
        type: COLUMN_TYPES.BOOL,
        colProps: {
          ...getDefaultProps(200),
          searchable: false,
        },
      },
    },
    {
      name: 'Edit',
      apiRef: '__actions__', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: ['Link'],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='write square'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() => onRowAction(actionCellActionType, rowIndex, primaryId)}
      />
    )

/**
 *
 * @param {*} fieldDefinitions
 * THIS SELECTOR IS TO MAINTAIN BACKWARDS COMPATIBILITY WITH EVERYTHING IN TOOLKIT
 * It will change/ be removed when everything there changes. This is so we can refactor slowly
 */
export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(ENDPOINTS, tableConfig)
